import { FC, useEffect, useMemo } from 'react';
import { CartogramActions } from './CartogramActions';
import { CartogramFilters } from './CartogramFilters';

import { Spin } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { observer } from 'mobx-react';
import { useCartogramStore } from '../context';
import {
  LegendSettingsForm,
  LegendsSettingsFormInstance,
} from './CartogramMapLegend';

import './style.scss';

export const Cartograms: FC = observer(function Cartograms() {
  const {
    filters,
    legendsSettings,
    features,
    mapController,
    ...cartogramStore
  } = useCartogramStore();

  const [form] = useForm<LegendsSettingsFormInstance>();

  const isActionsDisabled =
    features.isLoading || !filters.cartogram || !filters.tableColumn;

  useEffect(() => {
    cartogramStore.bind();
    legendsSettings.setForm(form);

    return () => {
      cartogramStore.unbind();
      legendsSettings.setForm(undefined);
    };
  }, []);

  const content = useMemo(() => {
    if (features.isLoading)
      return (
        <div className="cartograms__loader">
          <Spin />
        </div>
      );
    if (filters.cartogram && filters.tableColumn)
      return (
        <LegendSettingsForm
          form={form}
          onValuesChange={(changedValues, values) => {
            if ('settings' in changedValues)
              legendsSettings.setSettings(values.settings);
          }}
        />
      );

    return <></>;
  }, [features.isLoading, filters.cartogram, filters.tableColumn]);

  return (
    <div className="cartograms__container">
      <CartogramActions
        isDisabled={isActionsDisabled}
        className="cartograms__actions"
      />
      <CartogramFilters />

      <div className="cartograms__body">{content}</div>
    </div>
  );
});
